import { render, staticRenderFns } from "./ContactDetailsAddNewProp.vue?vue&type=template&id=fedf7da0&"
import script from "./ContactDetailsAddNewProp.vue?vue&type=script&lang=js&"
export * from "./ContactDetailsAddNewProp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports